import { theme } from '../../theme'

export const removeIconSVG = (
  <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg" className="removeIcon">
    <path d="M9 1L1 9M9 9L1 1" stroke={theme.colors.softBlack} strokeWidth="2" strokeLinecap="round" />
  </svg>
)
